import React from 'react';
import ClientInvoicesView from '../ClientInvoicesView';
import ClientQuotesView from '../ClientQuotesView';
import '../../styles/components/EditProjectPage.css';

interface ProjectBillingPanelProps {
  projectId: string;
  /** The project's client; New invoice / New quote start with it chosen. */
  clientId?: string | null;
}

/**
 * A project's invoices and quotes. These are the same lists as the account's
 * Invoices and Client Quotes pages, narrowed to this project, so status,
 * totals (hidden from anyone who may not see money) and row actions behave
 * identically; the New buttons open the usual forms with this project and its
 * client already chosen.
 */
const ProjectBillingPanel: React.FC<ProjectBillingPanelProps> = ({ projectId, clientId }) => (
  <div className="pb-panel">
    <section aria-labelledby="pb-invoices-title">
      <h3 className="pb-title" id="pb-invoices-title">Invoices</h3>
      <ClientInvoicesView projectId={projectId} projectClientId={clientId} />
    </section>
    <section aria-labelledby="pb-quotes-title">
      <h3 className="pb-title" id="pb-quotes-title">Quotes</h3>
      <ClientQuotesView projectId={projectId} projectClientId={clientId} />
    </section>
  </div>
);

export default ProjectBillingPanel;
